import DisplayChannel from "./channeldisplay";
import EmailChannel from "./channelemail";
import OrganicChannel from "./channelorganic";
import PaidChannel from "./channelpaid";
import SocialChannel from "./channelsocial";
import {ParsedUrlParams, UrlParams} from "./urlparams";
import Referrer from "./referrer";

enum Channel {
    Email = 'Email',
    Direct = 'Direct',
    Organic = 'Organic',
    Social = 'Social',
    Referral = 'Referral',
    Display = 'Display',
    PaidSearch = 'Paid Search',
}


export default class ChannelGrouping {

    urlParams: UrlParams;
    referrer: Array<string>;
    socialPlatform: string;

    public constructor(params: UrlParams) {
        this.urlParams = params;
        this.referrer = Referrer.get();
    }

    public static get(parsed: ParsedUrlParams) : Channel {
        if (EmailChannel.is(parsed)) {
            return Channel.Email;
        } 
        
        if (DisplayChannel.is(parsed)) {
            return Channel.Display;
        } else if (PaidChannel.is(parsed)) {
            return Channel.PaidSearch;
        }

        const referrer = Referrer.get();
        if (referrer.length === 1) {
            if (OrganicChannel.is(referrer[0])) {
                return Channel.Organic;
            } 
            const socialResult = SocialChannel.is(referrer[0]);
            if (typeof(socialResult) === 'string') {
                return Channel.Social;
            }
            return Channel.Referral;
        }

        return Channel.Direct;
    }

}
